import { render, staticRenderFns } from "./44.vue?vue&type=template&id=289b4993&"
import script from "./44.vue?vue&type=script&lang=js&"
export * from "./44.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports